import React from "react";
import { Modal, Box, Typography, Button, CircularProgress } from "@mui/material";
import { tokens } from "../../../Common/designTokens";

/**
 * The last "are you sure" step before an RFQ cancel is sent: the question, No and Yes.
 * Nothing is sent until Yes; No just closes this step.
 *
 * Used by RfqCancellationConfirmPopup (after its Yes / Cancel List) and by the Cancel List
 * button on the read-only list view, so both ask the same way.
 */
const RfqFinalConfirmPopup = ({ open, message, loading = false, onNo, onYes }) => (
  <Modal open={open} onClose={loading ? undefined : onNo} aria-labelledby="rfq-cancel-final-confirmation">
    <Box
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 460,
        bgcolor: tokens.colors.bodyBackgroundColor,
        border: `1px solid ${tokens.colors.bodyBorderColor50}`,
        boxShadow: 24,
        p: 3,
        borderRadius: 2,
        display: "flex",
        flexDirection: "column",
        gap: 2,
        alignItems: "center",
      }}
    >
      <Typography
        id="rfq-cancel-final-confirmation"
        variant="body1"
        sx={{ color: tokens.colors.fontColour, textAlign: "center" }}
      >
        {message}
      </Typography>
      <Box sx={{ display: "flex", gap: 2, mt: 1 }}>
        <Button
          variant="outlined"
          onClick={onNo}
          disabled={loading}
          sx={{ textTransform: "none", minWidth: 100 }}
        >
          No
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={onYes}
          disabled={loading}
          startIcon={loading ? <CircularProgress size={18} color="inherit" /> : null}
          sx={{ textTransform: "none", minWidth: 100 }}
        >
          {loading ? "Cancelling..." : "Yes"}
        </Button>
      </Box>
    </Box>
  </Modal>
);

export default RfqFinalConfirmPopup;
